import React from 'react'

import { ZariContext } from '_zari/context'
import { Modal, Col, Row, Button, Table } from '_zari/core'

import * as CategoriaService from 'services/categoria.service'

import { IdGen, ZrSwal } from 'utils'

import * as Sections from './sections'

const CrudContactosModal = ({ show, handleClose }) => {
  const __zariContext = React.useContext(ZariContext)

  const [sectionKey, setSectionKey] = React.useState(IdGen.newId())

  const tablaRef = React.useRef()
  const edicionDataRef = React.useRef({})

  const clickEditar = React.useCallback(
    id => {
      CategoriaService.obtenerxIdAsEdicion(id)
        .then(({ data }) => {
          edicionDataRef.current = data
          setSectionKey(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.toast('error', error))
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    id => {
      ZrSwal.showAlert({
        mensaje: 'Seguro que deasea eliminar el registro?',
        showCerrar: true,
        tipo: 'error',
        onSuccess: () => {
          CategoriaService.eliminarxId(id)
            .then(() => {
              __zariContext.toast('success', 'Registro eliminado.')
              tablaRef.current.reload()
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      })
    },
    [__zariContext]
  )

  const refrescarSection = React.useCallback(() => {
    edicionDataRef.current = {}
    setSectionKey(IdGen.newId())
  }, [])

  const refrescarTabla = React.useCallback(() => {
    tablaRef.current.reload()
  }, [])

  return (
    <Modal show={show} onHide={handleClose} size='xl'>
      <Modal.Header>
        <Modal.Title>Control Categorias</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <Table.ServerSide
              ref={tablaRef}
              useFilters={true}
              url='/categorias'
              headRows={[
                {
                  label: 'NOMBRE',
                  filter: {
                    type: 'text',
                    name: 'nom'
                  }
                },
                { label: '', width: 40 }
              ]}
              rowTemplate={row => (
                <Table.Row hover key={row._id}>
                  <Table.Cell>{row.nombre || '--'}</Table.Cell>
                  <Table.Cell>
                    <Table.Dropdown>
                      {({ handleClose }) => [
                        <Table.Dropdown.Item
                          key='editar'
                          handleClose={handleClose}
                          onClick={() => clickEditar(row._id)}
                        >
                          Editar
                        </Table.Dropdown.Item>,
                        <Table.Dropdown.Item
                          key='eliminar'
                          handleClose={handleClose}
                          onClick={() => clickEliminar(row._id)}
                        >
                          Eliminar
                        </Table.Dropdown.Item>
                      ]}
                    </Table.Dropdown>
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </Col>
          <Col md={6}>
            <Sections.CrearEditarCategoriaSection
              key={sectionKey}
              editarData={edicionDataRef.current}
              refrescarSection={refrescarSection}
              refrescarTabla={refrescarTabla}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' outline onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(CrudContactosModal)
